import * as React from 'react';
import { App } from '@app/src/views';
import { Login } from '@app/src/views/Login/login';
import { CreatePassword } from '@app/src/views/Login/createPassword';
import { CipGeneration } from '@app/src/views/CipGeneration';
import { CipReport } from '@app/src/views/CipReport';
import { Users } from '@app/src/views/Users';
import { CreateUsers } from '@app/src/views/CreateUsers';
import { EditUsers } from '@app/src/views/EditUser';
import { LoginMfa } from '@app/src/views/LoginMfa/loginMfa';
import { UserServices } from '@app/src/views/UserServices';
import { RequireFlowMerchants } from './RequireFlowMerchants';

const NotFound: React.FC<{}> = () => (
  <>NotFound</>
);

export const routes = [
  {
    component: App,
    routes: [
      {
        path: '/',
        component: Login,
        exact: true
      },
      {
        path: '/mfa',
        component: LoginMfa,
        exact: true
      },
      {
        path: '/actualizarcontrasena/:token',
        component: CreatePassword,
        exact: true
      },
      {
        path: '/generarcip',
        render: (routeProps: any) => (
          <RequireFlowMerchants>
            <CipGeneration {...routeProps} />
          </RequireFlowMerchants>
        ),
        exact: true
      },
      {
        path: '/servicios',
        render: (routeProps: any) => (
          <RequireFlowMerchants>
            <UserServices {...routeProps} />
          </RequireFlowMerchants>
        ),
        exact: true
      },
      {
        path: '/reportecip',
        render: (routeProps: any) => (
          <RequireFlowMerchants>
            <CipReport {...routeProps} />
          </RequireFlowMerchants>
        ),
        exact: true
      },
      {
        path: '/usuarios',
        render: (routeProps: any) => (
          <RequireFlowMerchants>
            <Users {...routeProps} />
          </RequireFlowMerchants>
        ),
        exact: true
      },
      {
        path: '/usuarios/crear',
        render: (routeProps: any) => (
          <RequireFlowMerchants>
            <CreateUsers {...routeProps} />
          </RequireFlowMerchants>
        ),
        exact: true
      },
      {
        path: '/usuarios/editar',
        render: (routeProps: any) => (
          <RequireFlowMerchants>
            <EditUsers {...routeProps} />
          </RequireFlowMerchants>
        ),
        exact: true
      },
      {
        path: '*',
        component: NotFound
      }
    ]
  }
]
